/* src/views/voyageurs/VoyageursDemandesCtrl.jsx — DEMANDES DIRECTES (lot 6).
   Décision Dimitri : « ma feuille par-dessus l'écran existant, avec ton
   verrou de logement non prêt ». L'écran existant (BookingRequestsView)
   est monté TEL QUEL — seules ses actions Valider/Rejeter ouvrent les
   feuilles du proto (props additives). TEXTES VRAIS (contrat §4) :
   - les dates ne se ferment sur les plateformes qu'AU PAIEMENT (après
     signature) — jamais « dès l'acceptation » (comportement serveur
     mesuré, verrou 1 au checkout) ;
   - une demande sans réponse expire à 48 HEURES ;
   - refus = texte libre ; les 4 raccourcis de la maquette REMPLISSENT le
     texte (zéro changement serveur) ; case « inclure le motif » sinon
     message générique. */
import React, { useState } from 'react'
import { supabase } from '../../supabase'
import BookingRequestsView from '../../tabs/messages/BookingRequestsView'

const fmtE = (v) => (v == null ? null : `${Number(v).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €`)

const MOTIFS = [
  'Les dates ne sont plus libres',
  'Le logement ne convient pas à ce groupe',
  'Un autre logement pourrait convenir',
  'Sans raison particulière',
]

async function decider(requestId, action, corps) {
  const jeton = (await supabase.auth.getSession()).data?.session?.access_token
  const r = await fetch('/api/sites?action=site_booking_validate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${jeton}` },
    body: JSON.stringify({ request_id: requestId, action, ...corps }),
  })
  const j = await r.json().catch(() => ({}))
  if (!r.ok || j?.ok === false) throw new Error(j?.error || `refusé (${r.status})`)
  return j
}

const Ligne = ({ n, texte, quand, dernier }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderTop: n > 1 ? '1px solid #e3e8ee' : 'none' }}>
    <span style={{ width: 22, height: 22, borderRadius: 7, background: '#e4f0fb', color: '#3d5166', fontSize: 10, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{n}</span>
    <span style={{ flex: 1, minWidth: 0, fontSize: 12, color: '#2e3d4d' }}>{texte}</span>
    <span style={{ fontSize: 10, color: '#5c6773', flexShrink: 0, textAlign: 'right' }}>{quand}</span>
  </div>
)

function Feuille({ titre, onFermer, children }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', zIndex: 300, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }} onClick={onFermer}>
      <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', width: '100%', maxWidth: 640, maxHeight: '86vh', overflowY: 'auto', padding: 16 }} onClick={(e) => e.stopPropagation()}>
        <p style={{ fontSize: 14, fontWeight: 700, color: '#2e3d4d', margin: '0 0 12px' }}>{titre}</p>
        {children}
      </div>
    </div>
  )
}

export default function VoyageursDemandesCtrl({ cfg, onDecision }) {
  const [feuille, setFeuille] = useState(null) // {type:'accepter'|'refuser', r}
  const [motif, setMotif] = useState(MOTIFS[0])
  const [texteRefus, setTexteRefus] = useState(MOTIFS[0])
  const [inclure, setInclure] = useState(true)
  const [envoi, setEnvoi] = useState(false)
  const [erreur, setErreur] = useState(null)
  const [rafraichir, setRafraichir] = useState(0)

  const nomDe = (r) => `${r.guest_first_name || ''} ${r.guest_last_name || ''}`.trim() || 'le voyageur'
  const ouvrir = (type, r) => { setErreur(null); setEnvoi(false); setMotif(MOTIFS[0]); setTexteRefus(MOTIFS[0]); setInclure(true); setFeuille({ type, r }) }

  const confirmer = async (action) => {
    const r = feuille.r
    setEnvoi(true); setErreur(null)
    try {
      await decider(r.id, action, action === 'rejected'
        ? { notes: texteRefus, rejection_reason_public: inclure ? texteRefus : '' }
        : {})
      setFeuille(null)
      setRafraichir((x) => x + 1) // remonte l'écran existant → il recharge
      if (onDecision) onDecision()
    } catch (e) { setErreur(e.message); setEnvoi(false) }
  }

  return (
    <div data-testid="voy-demandes">
      {/* L'écran existant, TEL QUEL — remonté après une décision pour recharger. */}
      <BookingRequestsView key={rafraichir} cfg={cfg}
        ouvrirAcceptation={(r) => ouvrir('accepter', r)}
        ouvrirRefus={(r) => ouvrir('refuser', r)} />

      {feuille?.type === 'accepter' && (() => {
        const r = feuille.r
        // Verrou « logement non prêt » (décision Dimitri) : sans devis calculé,
        // rien ne peut partir — bouton inactif et l'écran dit ce qui manque.
        const pret = r.total_amount_snapshot != null
        return (
          <Feuille titre={`Accepter la demande de ${nomDe(r)}`} onFermer={() => setFeuille(null)}>
            {!pret && (
              <div style={{ background: '#faeae4', border: '1px solid #eac8bb', borderRadius: 11, padding: '10px 11px', marginBottom: 10 }} data-testid="feuille-verrou-non-pret">
                <p style={{ fontSize: 11.5, fontWeight: 600, margin: 0, color: '#b8412b' }}>Ce logement n'est pas prêt pour le direct</p>
                <p style={{ fontSize: 10.5, margin: '4px 0 0', color: '#b8412b', opacity: 0.85, lineHeight: 1.5 }}>
                  Le devis n'a pas pu être calculé — il manque un réglage du logement
                  (forfait ménage, barème de taxe ou caution). Rien ne peut être envoyé
                  au voyageur tant que la fiche n'est pas complète.
                </p>
              </div>
            )}
            <div className="info">En acceptant, <b>quatre choses partent</b> au voyageur, dans cet ordre — les vrais délais :</div>
            <div className="carte" style={{ margin: 0 }}>
              <Ligne n={1} texte="Le lien de son espace séjour, avec le contrat à signer" quand="tout de suite" />
              <Ligne n={2} texte="Le paiement du séjour" quand="après signature (48 h pour payer)" />
              <Ligne n={3} texte="La demande de caution" quand="ouverte 2 jours avant l'arrivée" />
              <Ligne n={4} texte="Les instructions d'arrivée" quand="la veille au soir" />
            </div>
            {r.total_amount_snapshot != null && (
              <div className="carte" style={{ margin: '9px 0 0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                  <span style={{ fontSize: 12, color: '#5a6470' }}>Il devra régler</span>
                  <b style={{ fontSize: 17, color: '#2e3d4d' }}>{fmtE(r.total_amount_snapshot)}</b>
                </div>
              </div>
            )}
            <div className="warn" data-testid="feuille-warn-verrou">
              Les dates ne se ferment sur vos plateformes <b>qu'au moment où le voyageur
              paie</b> (après sa signature) — entre l'acceptation et le paiement, elles
              restent vendables ailleurs. S'il abandonne, rien n'est bloqué.
            </div>
            {erreur && <div className="warn">L'acceptation n'est pas partie : {erreur}</div>}
            <div className="act">
              <button className="bt bt-p" disabled={!pret || envoi} style={!pret || envoi ? { opacity: 0.4, cursor: 'default' } : undefined}
                onClick={() => confirmer('validated')} data-testid="feuille-accepter-confirmer">
                {envoi ? 'Envoi…' : 'Accepter et envoyer le lien'}
              </button>
              <button className="bt bt-s" onClick={() => setFeuille(null)}>Annuler</button>
            </div>
          </Feuille>
        )
      })()}

      {feuille?.type === 'refuser' && (
        <Feuille titre={`Refuser la demande de ${nomDe(feuille.r)}`} onFermer={() => setFeuille(null)}>
          <div className="info">Le voyageur reçoit un message. <b>Choisissez ce qu'il dira</b> — un refus sans raison laisse une mauvaise impression.</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
            {MOTIFS.map((m) => (
              <button key={m} onClick={() => { setMotif(m); setTexteRefus(m) }}
                style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left', border: motif === m ? '2px solid #3d5166' : '1px solid #e3e8ee', borderRadius: 12, padding: '9px 11px', background: motif === m ? '#e4f0fb' : '#fff', minHeight: 44, cursor: 'pointer' }}>
                <span style={{ width: 18, height: 18, borderRadius: '50%', border: motif === m ? '5px solid #3d5166' : '1.5px solid #c3cdd6', flexShrink: 0 }} />
                <span style={{ flex: 1, minWidth: 0, fontSize: 12, fontWeight: motif === m ? 600 : 400 }}>{m}</span>
              </button>
            ))}
          </div>
          {/* Le raccourci REMPLIT le texte — libre à vous de l'ajuster (le vrai
              serveur attend un texte libre, pas un code de motif). */}
          <p className="inter">Ce qu'il recevra</p>
          <textarea value={texteRefus} onChange={(e) => setTexteRefus(e.target.value)} rows={3}
            style={{ width: '100%', border: '1px solid #d5e3ee', borderRadius: 10, padding: 10, fontSize: 12, lineHeight: 1.5, color: '#2e3d4d', fontFamily: 'inherit' }} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 11.5, color: '#5a6470', margin: '8px 0 0', cursor: 'pointer' }}>
            <input type="checkbox" checked={inclure} onChange={(e) => setInclure(e.target.checked)} />
            Inclure ce motif dans l'email (sinon il recevra un message générique)
          </label>
          <p className="note">Les dates restent libres : refuser ne les bloque pas.</p>
          {erreur && <div className="warn">Le refus n'est pas parti : {erreur}</div>}
          <div className="act">
            <button className="bt bt-p" disabled={envoi} onClick={() => confirmer('rejected')} data-testid="feuille-refuser-confirmer">
              {envoi ? 'Envoi…' : 'Refuser et prévenir'}
            </button>
            <button className="bt bt-s" onClick={() => setFeuille(null)}>Annuler</button>
          </div>
        </Feuille>
      )}
    </div>
  )
}
